import React from 'react';
import './terms-delivery-details.scss';
import { InputWrapper } from '../input-wrapper';

const terms_Delivery_Details = [
  {
    key: 'termsOfDelivery',
    label: 'Enter terms of delivery for the customer',
    placeholder: 'Enter here...',
  },
];

interface TermsDeliverynDetailsProps {
  formData: Record<string, string | string[]>;
  onChange: (key: string, value: string) => void;
}

export const TermsDeliveryDetails: React.FC<TermsDeliverynDetailsProps> = ({
  formData,
  onChange,
}) => {
  return (
    <div className="terms-delivery-details">
      {terms_Delivery_Details.map((field) => (
        <div key={field.key} className="terms-delivery-details--field">
          {field.label && (
            <label className="terms-delivery-details--label font-medium">
              {field.label}
            </label>
          )}

          <InputWrapper
            placeholder={field.placeholder}
            value={(formData[field.key] as string) ?? ''}
            onChange={(value) => onChange(field.key, value)}
            multiline
          />
        </div>
      ))}
    </div>
  );
};
